import { FC, useContext } from "react";
import { useNavigate } from "react-router-dom";
import FeatureIntro from "../../components/FeatureIntro";
import { UIConfigContext } from "../../context/UIConfigContext";
import { AuthContext } from "../../context/AuthContext";
import DisplayPlanCard from "../../components/PlanCard/DisplayPlanCard";
import BookmarkCard from "../../components/BookmarkCard";
import CrystalCard from "../../components/CrystalCard";
import ManageFirewallaCard from "../../components/ManageFirewallaCard";
import Title from "../../components/Title";
import DiscountBanner from "../../components/DiscountBanner";
import "./index.css";
import { Button } from 'antd'
import { gotoOAuthPortal } from "../../services/auth";
import cardStyles from "../../components/ManageFirewallaCard/index.module.css";

const Home: FC = () => {
  const navigate = useNavigate();

  const { config } = useContext(UIConfigContext);
  const { email } = useContext(AuthContext);

  return (
    <>
      <main>
        <section
          className="call-for-action"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL + "/images/homepage-bg-map.svg"}), linear-gradient(180deg, #151231 0%, #080914 100%)`,
            paddingTop: 88,
          }}
        >
          {
            config?.isDiscountEnabled &&
            <DiscountBanner withButton={true} />
          }
          <div style={{ width: '100%', margin: '56px 0', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 32 }}>
            <Title
              size="large"
              theme="dark"
              style={{
                textAlign: "center",
              }}
            >
              {config?.headline || "title"}
            </Title>
            {
              email ?
                <ManageFirewallaCard /> :
                <>
                  <div style={{ color: "#fff", fontSize: 20 }}>
                    {config?.sub_headline}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
                    <button
                      type="button"
                      className={cardStyles["btn-primary"]}
                      data-gtm-id="hero_sign_up"
                      onClick={() => gotoOAuthPortal("signup")}
                    >
                      Sign Up for Firewalla MSP
                    </button>
                    <div style={{ color: "#8E8E8E", fontSize: 14 }}>
                      Already have an account?
                      <Button type="link" size="small" data-gtm-id="hero_sign_in" onClick={() => gotoOAuthPortal("login")}>
                        Sign in
                      </Button>
                    </div>
                  </div>
                </>
            }
          </div>
          <iframe
            className="intro-video"
            width={840}
            src={config?.video_embed.src}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </section>
        <section className="choose-plan">
          <BookmarkCard title="Choose Your MSP Plan" learnMoreLink="/plans" gtmId="view_msp_plans">
            <div className="plans">
              {config?.plans.map((plan) => {
                return (
                  <DisplayPlanCard
                    key={plan.id}
                    name={plan.name}
                    type={plan.id}
                    features={plan.key_features_desc}
                    style={{ flex: 1, maxWidth: "100%" }}
                  />
                );
              })}
            </div>
          </BookmarkCard>
        </section>
        {config?.crystal && (
          <section className="choose-crystal">
            <CrystalCard {...config.crystal} />
          </section>
        )}
        <section className="features" id="features">
          {config?.key_features.map((feature, index) => {
            return (
              <FeatureIntro
                key={index}
                order={index % 2 === 0 ? "image-text" : "text-image"}
                imageSource={feature.img}
                title={feature.title}
                descriptions={feature.desc}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f5f5f7" : "inherit",
                }}
              />
            );
          })}
        </section>
      </main>
    </>
  );
};

export default Home;
